import React, { Component } from 'react';
import './style.css';

import 'react-chat-widget/lib/styles.css';

import { Widget, setBadgeCount, renderCustomComponent, isWidgetOpened } from 'react-chat-widget';
// , markAllAsRead, addLinkSnippet

import AgoraRTM from 'agora-rtm-sdk'

class CustomMessageComponent extends Component {
  constructor(props) {
    super(props);
  }  
  
  render() {
    return (
      <div className="rcw-message">
        { this.props.profileAvatar &&
          <img src={this.props.profileAvatar} className="rcw-avatar" alt="profile"/>
        }
        <div className="rcw-response">
          { this.props.nickname &&
            <span className="rcw-nickname">{this.props.nickname}</span>
          }
          <div className="rcw-message-text">
            <p>{this.props.message}</p>
          </div>
          <span className="rcw-timestamp">{this.props.timestamp || new Date().toLocaleTimeString()}</span>
        </div>
      </div>
    );
  }
}

class TextChat extends Component {
  constructor(props) {
    super(props);
    
    this.AGORA_APP_ID = '0c801d6b0d55406582213b48e5468038';
    
    this.state = {
      //badge_count: 0,
      subtitle_images: []
    };

    this.badge_count = 0;

    this.rtm_client = AgoraRTM.createInstance(this.AGORA_APP_ID);
    
    console.log("TextChat constructor",this.props.chat_info.entity_uuid);
    this.rtm_channel = this.rtm_client.createChannel(this.props.chat_info.entity_uuid);
    
    this.member_list = [];

    this.rtm_channel.on('MemberLeft', (memberId) => {
      console.log("MEMBER LEFT",memberId);
      this.setup_subtitle_images();
    });
    this.rtm_channel.on('MemberJoined', (memberId) => {
      console.log("MEMBER JOINED",memberId);
      this.setup_subtitle_images();
    });

    this.rtm_channel.on('ChannelMessage', (message, memberId) => {
      console.log("rtm_client MessageFromPeer",message,memberId);
      let other_user_info = this.props.chat_info.users.find( element => element.entity_uuid === memberId );
      let tmp_date = new Date();
      
      let timestamp = (tmp_date.getHours() % 12)+':'+tmp_date.getMinutes(); // just to make it look like local message
      renderCustomComponent(CustomMessageComponent,{message:message.text,timestamp,nickname:other_user_info.entity_name,profileAvatar:other_user_info.adjusted_image_url},false);

      // weird Widget badge hack
      if (!isWidgetOpened()) {
        setBadgeCount(this.badge_count+1);
        //this.setState({badge_count:this.state.badge_count+1});
      }
    });
  }
  
  async componentWillUnmount() {
    await this.rtm_channel.leave();
  }
  
  setup_subtitle_images = async () => {
    this.member_list = await this.rtm_channel.getMembers();
    let tmp_subtitle_images = this.props.chat_info.users.map( (element,index) => {
      if (this.member_list.includes(element.entity_uuid)) {
        return (
          <img key={index} src={element.adjusted_image_url} className="rcw-avatar" alt="profile"/>
        );
      }
    });
    this.setState({ subtitle_images: tmp_subtitle_images });
  }
  
  /*
  componentDidUpdate (prevProps, prevState) {
    if (this.props.chat_info.users.length !== prevProps.chat_info.users.length) {
      let tmp_subtitle_images = this.props.chat_info.users.map( (element,index) => {
        return (
          <img key={index} src={element.adjusted_image_url} className="rcw-avatar" alt="profile"/>
        );
      });
      this.setState({ subtitle_images: tmp_subtitle_images });
    }
  }
  */

  async componentDidMount() {
    console.log("TextChat componentDidMount",this.props.rtm_token);
    await this.rtm_client.login({uid:this.props.user_info.entity_uuid,token:this.props.rtm_token});
    await this.rtm_channel.join();
    //this.member_list = await this.rtm_channel.getMembers();
    this.setup_subtitle_images();
  }

  handleNewUserMessage = async (message) => {
    await this.rtm_channel.sendMessage({ text: message });
  };
  
  handleToggle = () => {
    console.log("handleToggle",isWidgetOpened());
    if (isWidgetOpened()) {
      this.badge_count = 0;
      //this.setState({badge_count:0});
    }
  }

  render() {
    return (
      <React.Fragment>
        <div onClick={this.handleToggle} className={`${this.props.theme}`}>
          <Widget
            //handleToggle={this.handleToggle} // handleToggle here DOES NOT WORK, so put it in wrapper div
            handleNewUserMessage={this.handleNewUserMessage}
            title={this.props.chat_info.entity_name}
            subtitle={this.state.subtitle_images}
          />
        </div>
        </React.Fragment>
      );
  }
}

export default TextChat;